import * as images from "./images";

export const toShare = [
  // {
  //   img: null,
  //   nome: "Racy Spritz",
  //   ricetta: {
  //     it: "Racy Aperitivo, Prosecco, Frutta fresca",
  //     en: "Racy Aperitivo, Prosecco, Fresh fruit",
  //   },
  // },
  // {
  //   img: null,
  //   nome: "50 Shades of Grey Goose",
  //   ricetta: {
  //     it: "Vodka, Lampone, Mirtillo, Prosecco",
  //     en: "Vodka, Raspberry, Cranberry, Prosecco",
  //   },
  // },
];

export const gin = [
  {
    nome: "Berto",
    prezzo: 7.5,
  },
  {
    nome: "Malfi limone",
    prezzo: 9.5,
  },
  {
    nome: "Ophir",
    prezzo: 8.5,
  },
  {
    nome: "Sabatini",
    prezzo: 9.5,
  },
  {
    nome: "Botanist",
    prezzo: 9.5,
  },
  {
    nome: "Hendricks",
    prezzo: 8.5,
  },
  {
    nome: "Copper Head Gin",
    prezzo: 12.5,
  },
  {
    nome: "Elephant",
    prezzo: 9.5,
  },
  {
    nome: "Mare",
    prezzo: 8.5,
  },
  // {
  //   nome: "Colombian",
  //   prezzo: 8,
  // },
  {
    nome: "Sipsmith",
    prezzo: 8.5,
  },
  {
    nome: "Gutsy Monkey winter",
    prezzo: 13.5,
  },
  {
    nome: "Jizu",
    prezzo: 8.5,
  },
  // {
  //   nome: "David Luxury",
  //   prezzo: 11,
  // },
  // {
  //   nome: "Caprisius",
  //   prezzo: 8,
  // },
  {
    nome: "Del Professore Madame",
    prezzo: 9.5,
  },
  {
    nome: "Kinobi",
    prezzo: 11.5,
  },
  {
    nome: "Monkey 47",
    prezzo: 10.5,
  },
  {
    nome: "London Dry n3",
    prezzo: 8.5,
  },
  {
    nome: "Tanqueray",
    prezzo: 7.5,
  },
  {
    nome: "Tanqueray 10",
    prezzo: 10.5,
  },
  {
    nome: "Roku",
    prezzo: 8.5,
  },
  {
    nome: "Silent Pool",
    prezzo: 11.5,
  },
  {
    nome: "Seven Hills",
    prezzo: 8.5,
  },
  // {
  //   nome: "Ungava",
  //   prezzo: 7.5,
  // },
  {
    nome: "Brooklin",
    prezzo: 10.5,
  },
  {
    nome: "Alkkemist",
    prezzo: 10.5,
  },
  {
    nome: "Bombay",
    prezzo: 8.5,
  },
  {
    nome: "Peter in Florence",
    prezzo: 10.5,
  },
];
export const vodka = [
  {
    nome: "Ciroc",
    prezzo: 9.5,
  },
  {
    nome: "Grey Goose",
    prezzo: 10.5,
  },
  {
    nome: "Belvedere",
    prezzo: 10.5,
  },
  {
    nome: "Ketel One",
    prezzo: 8.5,
  },
  // {
  //   nome: "Nemiroff",
  //   prezzo: 6,
  // },
  {
    nome: "Tito's",
    prezzo: 9.5,
  },
];
export const rum = [
  {
    nome: "Don q Anejo",
    prezzo: 7.5,
  },
  {
    nome: "Matusalem 7yo",
    prezzo: 7.5,
  },
  {
    nome: "Brugal Anejo",
    prezzo: 7.5,
  },
  {
    nome: "Sailor Jerry",
    prezzo: 7.5,
  },
  {
    nome: "Don Papa 7yo",
    prezzo: 10,
  },
  {
    nome: "Diplomatico 12yo",
    prezzo: 12,
  },
  {
    nome: "Zacapa 23 anni",
    prezzo: 12,
  },
  {
    nome: "Zacapa XO",
    prezzo: 21,
  },
];
export const tequila = [
  // {
  //   nome: "Altos Blanco",
  //   prezzo: 6,
  // },
  // {
  //   nome: "Cazadores Blanco",
  //   prezzo: 6,
  // },
  {
    nome: "El Charro silver",
    prezzo: 6,
  },
  {
    nome: "Herradura Reposado",
    prezzo: 9,
  },
  {
    nome: "Arette Reposado",
    prezzo: 9,
  },
  {
    nome: "Mezcal A.D.C. JOVEN",
    prezzo: 9,
  },

  {
    nome: "Don Ramon Blanco",
    prezzo: 6,
  },
  {
    nome: "Don Ramon Reposado ",
    prezzo: 7,
  },

  {
    nome: "Casamigos Blanco",
    prezzo: 11,
  },
  {
    nome: "Casamigos Reposado",
    prezzo: 12,
  },
  {
    nome: "Casamigos Anejo",
    prezzo: 13,
  },
  {
    nome: "Don Julio Anejo",
    prezzo: 12,
  },
  {
    nome: "Don Julio 1942",
    prezzo: 37,
  },
  {
    nome: "Casamigos Mezcal",
    prezzo: 16,
  },
];
export const scothWisky = [
  {
    nome: "Black label JW",
    prezzo: 7,
  },
  {
    nome: "Chivas 12 anni",
    prezzo: 8,
  },
  {
    nome: "Talisker 10YO",
    prezzo: 10,
  },
  {
    nome: "Caol ila 12 YO",
    prezzo: 13,
  },
  {
    nome: "Laphroaig 10yo",
    prezzo: 10,
  },
  {
    nome: "Monkey Shoulder",
    prezzo: 10,
  },
  {
    nome: "Macallan 18 double cask",
    prezzo: 68,
  },
  {
    nome: "Caol Ila 18 y.o",
    prezzo: 32,
  },
];
export const usa = [
  {
    nome: "Bulleit Bourbon",
    prezzo: 8,
  },
  {
    nome: "Bulleit Rye",
    prezzo: 8,
  },
  {
    nome: "Woodfort Reserve",
    prezzo: 9,
  },
  {
    nome: "Makers's Mark",
    prezzo: 8,
  },
  {
    nome: "Makers's Mark 46",
    prezzo: 14,
  },
  {
    nome: "Michter's Bourdon",
    prezzo: 12,
  },
  {
    nome: "Jack Daniel",
    prezzo: 7,
  },
  {
    nome: "Jack Daniel Honey",
    prezzo: 8,
  },
];
export const japaniseWisky = [
  {
    nome: "Kaikyo Hatozaki ",
    prezzo: 13,
  },
  {
    nome: "Suntory Toki",
    prezzo: 9,
  },
  {
    nome: "AKASHI Blended",
    prezzo: 12,
  },
  {
    nome: "Nikka from the barrel",
    prezzo: 12,
  },
];
export const irishWisky = [
  {
    nome: "Jameson",
    prezzo: 7,
  },
];
export const cognac = [
  {
    nome: "Calvados Michel Biron",
    prezzo: 7,
  },
  {
    nome: "Leyrat",
    prezzo: 7,
  },
  {
    nome: "Remy Martin Vsop",
    prezzo: 9,
  },
  {
    nome: "Hennessy XO",
    prezzo: 23,
  },
];
export const grappa = [
  {
    nome: "Grappa Nonino",
    prezzo: 4,
  },
  {
    nome: "Berta Tre Soli Tre",
    prezzo: 18,
  },
  {
    nome: "Quaglia Barolo",
    prezzo: 8,
  },
];
export const caffetteria = [
  {
    nome: "Cornetto",
    prezzo: 2.5,
  },
  {
    nome: "Mini Cornetto",
    prezzo: 2,
  },
  {
    nome: "Espresso",
    prezzo: 2,
  },
  {
    nome: "Cappuccino",
    prezzo: 4,
  },
  {
    nome: "Latte Macchiato",
    prezzo: 4,
  },
  {
    nome: "Cortado",
    prezzo: 2.5,
  },
  {
    nome: "Americano",
    prezzo: 4,
  },
  {
    nome: "Doppio Espresso",
    prezzo: 4,
  },
  {
    nome: "Tea",
    prezzo: 4,
  },
  // {
  //   nome: "Caffe freddo",
  //   prezzo: 3,
  // },
  // {
  //   nome: "Yogurt",
  //   prezzo: 4,
  // },
  {
    nome: "Soft drink",
    prezzo: 3.5,
  },
  // {
  //   nome: "Flat white",
  //   prezzo: 3.5,
  // },
  {
    nome: "Spremuta",
    prezzo: 4,
  },
  {
    nome: "Cioccolata Calda",
    prezzo: 4,
  },
];
export const chocolate = [
  // {
  //   nome: "Venchi 1878",
  //   desc: "servita con marshmallow ",
  //   prezzo: 4,
  // },
  // {
  //   nome: "Antico Eremo Fondente",
  //   desc: "servita con marshmallow",
  //   prezzo: 4,
  // },
  // {
  //   nome: "Antico Eremo Bianca",
  //   desc: "servita con marshmallow",
  //   prezzo: 4,
  // },
  // {
  //   nome: "Antico Eremo Peperoncino",
  //   desc: "servita con marshmallow",
  //   prezzo: 4,
  // },
  // {
  //   nome: "Antico Eremo Cocco",
  //   desc: "servita con marshmallow",
  //   prezzo: 4,
  // },
  // {
  //   nome: "Cioc. fondente e lamponi",
  //   desc: "servita con marshmallow",
  //   prezzo: 4,
  // },
];
export const specialCoffie = [
  {
    nome: "Caffe Racy",
    desc: "Espresso, nocciola, latte, lemon zest    ",
    prezzo: 4,
  },
  // {
  //   nome: "Chai latte",
  //   desc: "Indian Chai, latte, cannella ",
  //   prezzo: 4,
  // },
  // {
  //   nome: "Pumpkin spice latte",
  //   desc: "Zucca, espresso, latte, cannella ",
  //   prezzo: 4,
  // },
  {
    nome: "Mocaccino",
    desc: "Espresso, cioccolata, latte",
    prezzo: 4,
  },
  {
    nome: "Iced Coffee",
    desc: "",
    prezzo: 5,
  },
];
export const tisane = [
  {
    nome: "Frutti rossi",
    prezzo: 3,
  },
  {
    nome: "Mela e cannella",
    prezzo: 3,
  },
  {
    nome: "Bonne nuit",
    desc: "(zenzero, cannella, limone, miele)",
    prezzo: 3,
  },
  {
    nome: "Indian Chai",
    prezzo: 3,
  },
  {
    nome: "Anice Stellato",
    prezzo: 3,
  },
  {
    nome: "Zenzero Fresco",
    prezzo: 3,
  },
];
export const latteVegetale = {
  nome: "Latte vegetale",
  tipi: ["Avena", "Soia", "Cocco", "Mandarla"],
  prezzo: "+0.50",
};
export const fullEnglishBreakfast = {
  nome: "Full English breakfast",
  tipi: [
    "Scrambled eggs",
    "Bacon",
    "Beans",
    "Mushroom ",
    "Turkey sausage",
    "Tomatoes",
    "Bread",
  ],
  prezzo: "15",
};
export const birra = [
  {
    nome: "Draught 40cl",
    prezzo: 7,
  },
  {
    nome: "Draught 20cl",
    prezzo: 5,
  },
  {
    nome: "Peroni Capri",
    prezzo: 6,
  },
  // {
  //   nome: "Umbri Bianca cappelli",
  //   prezzo: 7,
  // },
  {
    nome: "Umbri California",
    prezzo: 7,
  },
  {
    nome: "K birr NAPOLI lager",
    prezzo: 8,
  },
];
export const softDrink = [
  {
    nome: "Aperitivo analcolico",
    prezzo: 3.5,
  },
];
export const food = [
  {
    img: null,
    nome: {
      it: "Bruschette",
      en: "Bruschette",
    },
    prezzo: "10",
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Pizza sott'e 'ngopp",
      en: "Upside down Pizza",
    },
    prezzo: 10,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Insalata caprese",
      en: "Caprese salad",
    },
    prezzo: 12,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Pasta al pesto",
      en: "Pesto Pasta",
    },
    prezzo: 14,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Polpette al sugo",
      en: "Meatballs in sauce",
    },
    prezzo: 14,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Spaghetti Racy",
      en: "Pasta Racy style",
    },
    prezzo: 18,
    ricetta: {
      it: "Pomodoro, tequila, nduja, burrata",
      en: "Tomato, tequila, nduja, burrata",
    },
  },
  {
    img: null,
    nome: {
      it: "Riso Nero",
      en: "Black rice",
    },
    prezzo: 14,
    ricetta: {
      it: "Riso nero, pesto di basilico, pomodorini",
      en: "Black rice, basil pesto, cherry tomatoes",
    },
  },
  {
    img: null,
    nome: {
      it: "Insalatona Salmone",
      en: "Insalatona with salmon",
    },
    prezzo: 16,
    ricetta: {
      it: "Insalatona con salmone affumicato",
      en: "Hearty Salad with smoked salmon",
    },
  },
  {
    img: null,
    nome: {
      it: "Insalatona Pollo",
      en: "Chicken Salad",
    },
    prezzo: 14,
    ricetta: {
      it: "Insalatona con pollo",
      en: "Hearty Salad with grilled",
    },
  },
  // {
  //   img: null,
  //   nome: {
  //     it: "Tagliolini ai Porcini",
  //     en: "tagliolini with porcini mushrooms",
  //   },
  //   prezzo: 15,
  //   ricetta: {
  //     it: "",
  //     en: "",
  //   },
  // },
  {
    img: null,
    nome: {
      it: "Pollo al curry",
      en: "Chicken curry",
    },
    prezzo: 16,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Lasagna gluten free",
      en: "Gluten-free Lasagna",
    },
    prezzo: 14,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Zuppa",
      en: "Soup",
    },
    prezzo: 9,
    ricetta: {
      it: "con funghi Porcini",
      en: "Porcini mushrooms soup",
    },
  },
  // {
  //   img: null,
  //   nome: {
  //     it: "Gnocchi alla Sorrentina",
  //     en: "Gnocchi Sorrentina syle",
  //   },
  //   prezzo: 12,
  //   ricetta: {
  //     it: "Pomoro & Mozzarella",
  //     en: "Tomato & Mozzarella",
  //   },
  // },
  // {
  //   img: null,
  //   nome: {
  //     it: "Salumi & Formaggi",
  //     en: "Cold cuts & local cheese",
  //   },
  //   prezzo: 9,
  //   ricetta: {
  //     it: "",
  //     en: "",
  //   },
  // },
  {
    img: null,
    nome: {
      it: "Parmigiana di melenzane",
      en: "Eggplant Parmigiana",
    },
    prezzo: 14,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Lasagna",
      en: "Lasagna",
    },
    prezzo: 14,
    ricetta: {
      it: "",
      en: "",
    },
  },
  // {
  //   img: null,
  //   nome: {
  //     it: "'Caviale' di Lompo",
  //     en: "Lumpfish 'caviar'",
  //   },
  //   prezzo: 12,
  //   ricetta: {
  //     it: "Servito con crostini al burro",
  //     en: "Served with butter croutons",
  //   },
  // },
  {
    img: null,
    nome: {
      it: "Pasta carbonara",
      en: "Pasta carbonara",
    },
    prezzo: 14,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Tagliolini a limone",
      en: "Tagliolini with lemon sauce",
    },
    prezzo: 16,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Risotto alla pescatora",
      en: "Seafood risotto",
    },
    prezzo: 18,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Filetto pesce alla mediterranea",
      en: "Mediterranean fish fillet ",
    },
    prezzo: 19,
    ricetta: {
      it: "",
      en: "",
    },
  },
];
export const sandwwich = [
  {
    img: null,
    nome: {
      it: "Crudo e formaggio ",
      en: "Parma ham and cheese",
    },
    prezzo: 8,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Caprese",
      en: "Capri Style Sandwich",
    },
    prezzo: 9,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Salmone affumicato",
      en: "Smoked salmon sandwich",
    },
    prezzo: 12,
    ricetta: {
      it: "",
      en: "",
    },
  },
];
export const focaccie = [
  // {
  //   img: null,
  //   nome: {
  //     it: "Stracciata, Mortadella e granella di pistacchio ",
  //     en: "Stracciata cheese, mortadella and pistachios ",
  //   },
  //   prezzo: 12,
  //   ricetta: {
  //     it: "",
  //     en: "",
  //   },
  // },
  {
    img: null,
    nome: {
      it: "Stracciata e Crudo",
      en: "Stracciata cheese and Parma ",
    },
    prezzo: 12,
    ricetta: {
      it: "",
      en: "",
    },
  },
  {
    img: null,
    nome: {
      it: "Stracciata, Alici e limone",
      en: "Stracciata cheese, anchovies and lemon ",
    },
    prezzo: 12,
    ricetta: {
      it: "",
      en: "",
    },
  },
];
export const bruschette = {
  nome: {
    it: "Selezione di Bruschette:",
    en: "Bruschette with:",
  },
  bruschette: [
    // {
    //   it: "Tartufo",
    //   en: "Truffles",
    // },
    // {
    //   it: "Burro e alici",
    //   en: "Anchovies and Butter",
    // },
    // {
    //   it: "Salsiccia e friarielli ",
    //   en: "Sausage and friarielli",
    // },
    // {
    //   it: "Melanzane ",
    //   en: "Aubergine",
    // },
    // {
    //   it: "Pate' di olive nere",
    //   en: "Black olives pate'",
    // },
    // {
    //   it: "Crema di balisico ",
    //   en: "Basil cream",
    // },
    // {
    //   it: "Nduja calabrese",
    //   en: "Spicy Nduja calabrese",
    // },
    // {
    //   it: "Peperoni Arrostiti",
    //   en: "Roasted Peppers",
    // },
    // {
    //   it: "Patè di carciofini",
    //   en: "Artichoes Patè",
    // },
  ],
};

export const nachos = [
  {
    img: null,
    nome: {
      it: "Servito con burrata al basilico ",
      en: "With burrata & basil",
    },
    prezzo: "",
    ricetta: {
      it: "",
      en: "",
    },
  },
];

export const dessert = [
  // {
  //   prezzo: 6,
  //   nome: "Musse di San Valentino",
  //   desc: {
  //     it: "Mousse al cioccolato e gelè di lamponi",
  //     en: "Chocolate mousse and raspberry gelè",
  //   },
  // },
  {
    prezzo: 6,
    desc: {
      it: "Tiramisu",
      en: "Tiramisu",
    },
  },
  {
    prezzo: 6,
    desc: {
      it: "Sorbetto al limone",
      en: "Lemon sorbet",
    },
  },
  {
    prezzo: 6,
    desc: {
      it: "Tortino al cioccolato",
      en: "Chocolate cake",
    },
  },
  {
    prezzo: 6,
    desc: {
      it: "Affogato",
      en: "Affogato",
    },
  },
  {
    prezzo: 6,
    desc: {
      it: "Pizza Nutella",
      en: "Pizza Nutella",
    },
  },
  {
    prezzo: 6,
    desc: {
      it: "Pancake",
      en: "Pancake",
    },
  },
];
export const redWine = [
  {
    nome: "Sangue di Giuda",
    bottleCost: 27,
    glassCost: 7,
  },
  {
    nome: "Valpolicella Masi",
    bottleCost: 55,
  },
  // {
  //   nome: "Jungano San Salvatore",
  //   bottleCost: 45,
  // },
  {
    nome: "Barolo Lodali 2020",
    bottleCost: 55,
  },
  {
    nome: "Merlot La Viarte riserva 2013",
    bottleCost: 55,
  },
  // {
  //   nome: "Cabernet La Viarte riserva 2015 ",
  //   bottleCost: 50,
  // },
  {
    nome: "Cabernet Cesare ",
    bottleCost: 35,
  },
  {
    nome: "Moio 57",
    bottleCost: 32,
  },
  // {
  //   nome: "Barolo Prunotto 2019 ",
  //   bottleCost: 55,
  // },
  {
    nome: "Chianti Classico Carpineto",
    bottleCost: 32,
    glassCost: 9,
  },
  // {
  //   nome: "Barolo 2012 Castiglione Vietti",
  //   bottleCost: 64,
  // },
  {
    nome: "Amarone Costasera Masi 2017",
    bottleCost: 95,
  },
  {
    nome: "Amarone Villa Santi",
    bottleCost: 60,
  },
  // {
  //   nome: "Taurasi Feudi 2012",
  //   bottleCost: 65,
  // },
  {
    nome: "Taurasi Feudi 2019",
    bottleCost: 60,
  },
  // {
  //   nome: "Barolo Fontanafredda 2009 ",
  //   bottleCost: 157,
  // },
  // {
  //   nome: "Primitivo Conte Zecca",
  //   bottleCost: 30,
  // },
  {
    nome: "Primitivo 60 anni San Marzano",
    bottleCost: 63,
  },
  {
    nome: "Primitivo di Manduria",
    bottleCost: 28,
    glassCost: 7,
  },
];

export const whiteWine = [
  // {
  //   nome: "Fiano Macchialupa",
  //   bottleCost: 28,
  //   glassCost: 7,
  // },
  {
    nome: "Casa D'Ambra biancolella",
    bottleCost: 37,
  },
  // {
  //   nome: "FiaGre Antonio Caggiano",
  //   bottleCost: 28,
  //   glassCost: 7,
  // },
  // {
  //   nome: "Biancolella Casa d'Ambra",
  //   bottleCost: 30,
  // },
  // {
  //   nome: "Chardonnay Cantina Mori",
  //   bottleCost: 30,
  //   glassCost: 8,
  // },
  {
    nome: "Chardonnay Cesare",
    bottleCost: 30,
    glassCost: 8,
  },
  {
    nome: "Fiano Enodelta",
    bottleCost: 28,
    glassCost: 7,
  },
  {
    nome: "Pinot Grigio Lunardi",
    bottleCost: 30,
    glassCost: 8,
  },
  // {
  //   nome: "Quintodecimo Exultet Fiano",
  //   bottleCost: 60,
  // },
];
export const roseWine = [
  // {
  //   nome: "Visione Feudi di San Gregorio",
  //   bottleCost: 32,
  //   glassCost: 9,
  // },
  {
    nome: "Tramari Rosé",
    bottleCost: 39,
  },
  {
    nome: "Idea Rosé",
    bottleCost: 32,
    glassCost: 9,
  },
];
export const bollicine = [
  {
    nome: "Prosecco",
    bottleCost: 30,
    glassCost: 8,
  },
  {
    nome: "Krug 169 edition brut",
    bottleCost: 410,
  },
  // {
  //   nome: "CA del bosco",
  //   bottleCost: 65,
  // },
  {
    nome: "Louis Roederer 242",
    bottleCost: 110,
  },
  // {
  //   nome: "Laurent-Perrier Rosè",
  //   bottleCost: 120,
  // },
  {
    nome: "Bollinger special cuvee",
    bottleCost: 115,
  },
  {
    nome: "Belle Epoque 2013",
    bottleCost: 290,
  },
  // {
  //   nome: "Veuve clicquot 375ml",
  //   bottleCost: 60,
  // },
  {
    nome: "Franciacorta Camillucci Saten",
    bottleCost: 55,
  },

  {
    nome: "Laurent Perrier brut Champagne",
    bottleCost: 110,
  },
  {
    nome: "Brachetto Banfi",
    bottleCost: 30,
  },
  {
    nome: "Franciacorta Berlucchi",
    bottleCost: 50,
    glassCost: 12,
  },
];

export const hot = [
  {
    img: images.hot,
    nome: "Apple brulè",
    ricetta: {
      it: "Mela limoncella, vodka, spezie natalizie",
      en: "Apple limoncella, vodka, Christmas spices",
    },
  },
  // {
  //   img: images.hot,
  //   nome: "Anacleto",
  //   ricetta: {
  //     it: "Espresso, Cioccolata, Zabaione, Panna",
  //     en: "Espresso, Chocolate, Eggnog, Cream",
  //   },
  // },
  {
    img: images.hot,
    nome: "Afther 8",
    ricetta: {
      it: "Rum, cioccolato e menta",
      en: "Rum, chocolate, mint",
    },
  },
  // {
  //   img: images.hot,
  //   nome: "Chai Toddy",
  //   ricetta: {
  //     it: "Bourbon, Chai tea, limone, miele",
  //     en: "Bourbon, Chai tea, lemon, honey",
  //   },
  // },
  {
    img: images.hot,
    nome: "Caribbean",
    ricetta: {
      it: "Rum, caffè, cocco & cannella ",
      en: "Rum, caffè, cocco & cannella",
    },
  },
  // {
  //   img: images.hot,
  //   nome: "French kiss",
  //   ricetta: {
  //     it: "Calvados, Cioccolato fondente, Lamponi",
  //     en: "Calvados, Dark chocolate, Raspberries",
  //   },
  // },
  {
    img: images.hot,
    nome: "Aperol Spritz Caldo",
    ricetta: {
      it: "Aperol, vino secco, spezie",
      en: "Aperol, dry wine, spices",
    },
  },
];
export const shot = [
  // {
  //   img: null,
  //   nome: "Passion",
  //   ricetta: {
  //     it: "Cioccolato, Caffè",
  //     en: "Chocolate, Coffee",
  //   },
  // },
  // {
  //   img: null,
  //   nome: "Bacio",
  //   ricetta: {
  //     it: "Nocciola, Baileys",
  //     en: "Hazelnut, Baileys",
  //   },
  // },
  // {
  //   img: null,
  //   nome: "Punto G",
  //   ricetta: {
  //     it: "Mandorla, Caffè",
  //     en: "Almond, Coffee",
  //   },
  // },
];
export const merch = [
  // {
  //   imgs: [images.orologio, images.tshirt, images.giub],
  //   nome: "Orologio",
  //   cost: 10,
  //   ricetta: {
  //     it: "Elegante orologio da polso",
  //     en: "Elegant wrist watch",
  //   },
  // },
  {
    imgs: [images.tshirt, images.tshirt, images.tshirt],
    nome: "T-Shirt",
    cost: 12,
    ricetta: {
      it: "T-shirt casual e comoda",
      en: "Casual and comfortable t-shirt",
    },
  },
  {
    imgs: [images.tshirt_white, images.tshirt_white, images.tshirt_white],
    nome: "T-Shirt Bianca",
    cost: 12,
    ricetta: {
      it: "T-shirt bianca casual e comoda",
      en: "White casual and comfortable t-shirt",
    },
  },
  {
    imgs: [images.felpa, images.felpa, images.felpa],
    nome: "Maglia",
    cost: 28,
    ricetta: {
      it: "Felpa morbida e calda",
      en: "Soft and warm sweatshirt",
    },
  },
  {
    imgs: [images.giub, images.giub, images.giub],
    nome: "Giubbino",
    cost: 55,
    ricetta: {
      it: "Giubbino leggero e moderno",
      en: "Light and stylish jacket",
    },
  },
];
